import { labelForWorkOrderPrintOption, WorkOrderPrintOption } from "@model/workOrders/WorkOrderPrintOption"
import { Button } from "@ui/common/buttons/Button"
import { Grid, GridGap } from "@ui/common/grids/Grid"
import { Modal, ModalBody, ModalContent, ModalHeader, ModalHeaderTitle, ModalSize } from "@ui/common/Modal"
import ReactToPrint from "react-to-print";
import React, { useRef } from "react"
import { WorkOrderFormPDF } from "@lib/pdf/WorkOrderFormPDF";
import { PartsListFormPDF } from "@lib/pdf/PartsListFormPDF";
import { PDFAsset } from "@lib/pdf/models/PDFAsset";
import { PDFWorkOrder } from "@lib/pdf/models/PDFWorkOrder";
import { PDFAssetPart } from "@lib/pdf/models/PDFAssetPart";

export type PrintWorkOrderProps = {
    isVisible: boolean
    isLoading: boolean
    onOptionSelected?: (option: WorkOrderPrintOption) => void
    onClose: () => void
    asset?: PDFAsset
    workOrder?: PDFWorkOrder
    assetParts?: PDFAssetPart[]
    companyName?: string
    selectedPrintOption?: WorkOrderPrintOption
    companyLogoUrl: string | null    
    optionsEnabled?: Record<WorkOrderPrintOption, boolean>
}

export function PrintWorkOrderModal(props: PrintWorkOrderProps): JSX.Element {
    let componentRef = useRef<HTMLDivElement>(null)

    return (
        <Modal isVisible={props.isVisible} useContentTag={true} size={ModalSize.Small} onClose={props.onClose}>
            <ModalContent isLoading={props.isLoading}>
                <ModalHeader>
                    <ModalHeaderTitle>Print Work Order</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <Grid columns={1} gap={GridGap.Small}>
                        {Object.values(WorkOrderPrintOption).map((it) => (
                            <ReactToPrint
                                key={it.toString()}
                                trigger={() => <Button isEnabled={props.optionsEnabled?.[it] ?? true}>{labelForWorkOrderPrintOption(it)}</Button>}
                                content={() => componentRef.current}
                                onBeforeGetContent={() => props.onOptionSelected?.(it)
                                }                                
                            />
                        ))}
                        {((props.asset! || props.workOrder!) && props.selectedPrintOption!) &&
                            <>
                                <div style={{ display: "none" }}>
                                    <div ref={componentRef}>
                                        {getPdfComponent(props)}
                                    </div>
                                </div>
                            </>
                        }
                    </Grid>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
// Action Item 6764: every print option renders the form-style templates. The Summary
// options show collapsed Service Item cards; the Details options show extended ones.
function getPdfComponent(props: PrintWorkOrderProps): JSX.Element {
    if (props.selectedPrintOption == WorkOrderPrintOption.Summary) {
        return <WorkOrderFormPDF companyName={props.companyName!} asset={props.asset!} workOrder={props.workOrder!} companyLogoUrl={props.companyLogoUrl} extendedServiceItems={false} />
    }
    else if (props.selectedPrintOption == WorkOrderPrintOption.WorkOrder) {
        return <WorkOrderFormPDF companyName={props.companyName!} asset={props.asset!} workOrder={props.workOrder!} companyLogoUrl={props.companyLogoUrl} extendedServiceItems={true} />
    }
    else if (props.selectedPrintOption == WorkOrderPrintOption.Parts) {
        return <PartsListFormPDF companyName={props.companyName!} asset={props.asset!} parts={props.assetParts!} companyLogoUrl={props.companyLogoUrl} />
    }
    else if (props.selectedPrintOption == WorkOrderPrintOption.SummaryWithParts) {
        return <>
            <WorkOrderFormPDF companyName={props.companyName!} asset={props.asset!} workOrder={props.workOrder!} companyLogoUrl={props.companyLogoUrl} extendedServiceItems={false} />
            <PartsListFormPDF companyName={props.companyName!} asset={props.asset!} parts={props.assetParts!} companyLogoUrl={props.companyLogoUrl} />
        </>
    }
    else if (props.selectedPrintOption == WorkOrderPrintOption.WorkOrderWithParts) {
        return <>
            <WorkOrderFormPDF companyName={props.companyName!} asset={props.asset!} workOrder={props.workOrder!} companyLogoUrl={props.companyLogoUrl} extendedServiceItems={true} />
            <PartsListFormPDF companyName={props.companyName!} asset={props.asset!} parts={props.assetParts!} companyLogoUrl={props.companyLogoUrl} />
        </>
    }
    else {
        return <></>
    }
}